import { combineReducers } from '@reduxjs/toolkit';
import app from './app/reducer';
import auth from './auth/reducer';
import survey from './survey/reducer';
import evaluatedQuestion from './evaluatedQuestion/reducer';

export const rootReducer = (injectedReducers = {}) => {
  return combineReducers({
    app,
    auth,
    survey,
    evaluatedQuestion,
  });
};
